import { useLocation } from '@solidjs/router'
import { EmptyState } from '@veem/ui'
import { createEffect, ErrorBoundary, on, type ParentProps } from 'solid-js'
import { isStaleFile, reloadForNewVersion, reportClientError } from '../../lib/client-errors.ts'
import { Btn } from './button.tsx'

const PageFailure = (props: { error: unknown; reset: () => void }) => {
  const location = useLocation()
  // The menu stays usable: going to another page clears the failure.
  createEffect(
    on(
      () => location.pathname,
      () => props.reset(),
      { defer: true },
    ),
  )
  const stale = () => isStaleFile(props.error)
  createEffect(() => {
    if (stale()) reloadForNewVersion()
    else reportClientError(props.error)
  })
  return (
    <div class="grid justify-items-center gap-3 py-16">
      <EmptyState
        title={stale() ? 'Вийшло оновлення системи' : 'Сторінка не відкрилась'}
        description="Оновіть сторінку. Збережені дані на місці."
      />
      <Btn onClick={() => window.location.reload()}>Оновити сторінку</Btn>
    </div>
  )
}

/** Keeps one failed page from blanking the whole app. */
export const PageBoundary = (props: ParentProps) => (
  <ErrorBoundary fallback={(error, reset) => <PageFailure error={error} reset={reset} />}>
    {props.children}
  </ErrorBoundary>
)
